import { render, staticRenderFns } from "./AIMShow.vue?vue&type=template&id=7bac7af6&"
import script from "./AIMShow.vue?vue&type=script&lang=js&"
export * from "./AIMShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports